const PT = require("prop-types");
const createReactClass = require("create-react-class");

// Wrapper component taking render props, which starts a timer for some number
// of seconds.

module.exports = createReactClass({
	displayName: "TimerWrapper",

	propTypes: {
		// Assumed not to change after mount
		initialSeconds: PT.number.isRequired,
		// Takes (initialSeconds, left). If left is 0, time is up.
		render: PT.func.isRequired,
	},

	getNow: function() {
		return global.performance ? global.performance.now() : Date.now();
	},

	getInitialState: function() {
		return {
			seconds: this.props.initialSeconds,
			left: this.props.initialSeconds,
			startTime: Math.floor(this.getNow()),
		};
	},

	setUpdateTimeout: function() {
		if (this.state.left <= 0) return;
		const currTime = Math.floor(this.getNow());
		let newLeft = this.state.left - 1;
		let endTime =
			this.state.startTime + 1000 * (this.state.seconds - this.state.left + 1);
		if (endTime < currTime) {
			const overrunSeconds = Math.floor((currTime - endTime) / 1000);
			endTime = currTime;
			newLeft = Math.max(newLeft - overrunSeconds, 0);
		}
		setTimeout(() => this.setState({left: newLeft}), endTime - currTime);
	},

	componentDidMount: function() {
		this.setUpdateTimeout();
	},

	componentDidUpdate: function() {
		this.setUpdateTimeout();
	},

	render: function() {
		return this.props.render(this.state.seconds, this.state.left);
	},
});
